<template>
  <div>
    <a-card style="margin-bottom:24px">
      <a-row type="flex" :gutter="[16, 16]">
        <a-col :lg="6" :md="12" :xs="24" class="option-wrapper">
          <span>领域：</span>
          <h-cascader
            v-model="field"
            :options="mainFieldsOptions"
            :fieldNames="{
              label: 'name',
              value: 'id',
              children: 'children'
            }"
            change-on-select
            allowClear
            placeholder="全部分类"
            style="flex:1"
            @change="initData"
          />
        </a-col>
        <a-col :lg="6" :md="12" :xs="24" class="option-wrapper">
          <span>记录方式：</span>
          <h-select
            v-model="query.recordingMethod"
            allowClear
            placeholder="全部方式"
            style="flex:1"
            @change="() => initData()"
          >
            <a-select-option
              v-for="recodingMethodInfo in recordingMethodOptions"
              :key="recodingMethodInfo.value"
              :value="recodingMethodInfo.value"
            >
              {{ recodingMethodInfo.label }}
            </a-select-option>
          </h-select>
        </a-col>
        <a-col :lg="6" :md="12" :xs="24" class="option-wrapper">
          <span>状态：</span>
          <h-select v-model="query.status" allowClear placeholder="全部状态" style="flex:1" @change="() => initData()">
            <a-select-option v-for="statusInfo in statusOptions" :key="statusInfo.value" :value="statusInfo.value">
              {{ statusInfo.label }}
            </a-select-option>
          </h-select>
        </a-col>
        <a-col :lg="6" :md="12" :xs="24" class="option-wrapper">
          <span>搜索：</span>
          <a-input-search
            v-model="query.name"
            allowClear
            placeholder="请输入阶段名称"
            style="flex:1"
            @search="initData"
          />
        </a-col>
      </a-row>
    </a-card>

    <a-card title="阶段列表" :body-style="{ padding: 0 }">
      <div slot="extra">
        <a-button
          v-if="$auth('phases_add')"
          type="primary"
          shape="round"
          @click="$router.push('/skill-management/phase/create')"
        >
          <a-icon type="plus" /><span>添加</span>
        </a-button>
      </div>

      <phase-table ref="table"></phase-table>
    </a-card>
  </div>
</template>

<script>
import * as commonApi from '@/api/common'
import { RECORDING_METHOD, COMMON_STATUS } from '@/store/dictionary'
import PhaseTable from './components/Table'

export default {
  name: 'SkillManagementPhaseList',
  components: {
    PhaseTable
  },
  data() {
    return {
      query: {
        fieldId: undefined,
        mainFieldId: undefined,
        name: undefined,
        recordingMethod: undefined,
        status: undefined
      },
      field: [],
      mainFieldsOptions: [],
      recordingMethodOptions: RECORDING_METHOD,
      statusOptions: COMMON_STATUS
    }
  },
  activated() {
    this.initOptions()
  },
  mounted() {
    const { $nextTick, initData } = this

    $nextTick(() => {
      this.ready = true
    })

    initData()
  },
  methods: {
    initData() {
      const { field } = this

      this.query.mainFieldId = field[0]
      this.query.fieldId = field[1]

      this.$refs.table.initData(this.query)
    },
    initOptions() {
      commonApi.fieldsOptions().then(res => {
        this.mainFieldsOptions = res.data.filter(v => v.level === 'MAIN')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-advanced-search-form /deep/ .ant-form-item {
  display: flex;
  margin-bottom: 0;
}
.ant-advanced-search-form /deep/ .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
